import React from 'react'
import { Link } from 'react-router-dom'

function BreadcrumbsSection({page_name, routes}) {
  return (
    <div className="breadcrumbs_section">
            <div className="breadcrumbs_inner_wrapper">
                <p>
                   <Link to={routes.homePage.path}><span>Main</span></Link>
                    <span> &gt;&gt; </span>
                    <span style={{color:'black'}}>{page_name}</span>
                </p>
            </div>
        </div>
  )
}

export default BreadcrumbsSection